import styled from 'styled-components'

import { TypeStyle, fromLg, pageLayoutMaxWidthPixels } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  max-width: ${pageLayoutMaxWidthPixels}px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;

  padding: ${o => o.theme.spacing(5, 4)};
  padding-top: 0;

  ${fromLg} {
    padding: ${o => o.theme.spacing(12, 10)};
    padding-top: 0;
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TilesList = styled.ul`
  margin-top: ${o => o.theme.spacing(3)};

  > * {
    border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
    border-radius: 3px;
  }

  > * + * {
    margin-top: ${o => o.theme.spacing(2)};
  }

  ${fromLg} {
    ${o => o.theme.spacing(5)};

    > * {
      border-left: none;
      border-radius: 0;
      border-right: none;

      &:not(:last-of-type) {
        border-bottom: none;
      }
    }

    > * + * {
      margin-top: 0;
    }
  }
`

export const SizeChartButton = styled.button`
  ${TypeStyle.css.bodyMedium};
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  font-weight: ${o => o.theme.typography.font.weight[700]};
  text-decoration: underline;
  &:hover {
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.subtle};
  }
`
